module.exports = __webpack_public_path__ + "1@2x.61967bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/1@2x.png
// module id = /FAr
// module chunks = 0